import React from 'react';
import { Tooltip } from 'antd';
import { MindMapContext } from '../../Context/contex';
import './SavingStatus.css';

const SAVING = 'Saving...';
const SAVED = 'Saved';

const StatusLine = ({ isSaving = false, label, details }) => (
    <span className="saving-status__line">
        <span
            className={`saving-status__dot ${isSaving ? 'saving-status__dot--saving' : 'saving-status__dot--saved'}`}
            aria-hidden="true"
        />
        <span className="saving-status__label">
            {label}
            {details && <span className="saving-status__details"> &middot; {details}</span>}
        </span>
    </span>
);

const getDetails = ({ lastSavedDateTime, fileSize }) => (lastSavedDateTime ? `${lastSavedDateTime}, ${fileSize}` : fileSize);

/**
 * Status line under the title: an amber dot while saving, a green one once
 * saved, then muted text. A hidden copy of the saved line keeps the width
 * steady while "Saving..." shows, so the tools beside it do not jump.
 */
const SavingStatus = () => {
    const { savingData } = MindMapContext();
    const isSaving = savingData?.isSaving === SAVING;
    const details = savingData ? getDetails(savingData) : '';

    if (!isSaving && !details) return <div className="saving-status" />;

    const tooltip = isSaving ? 'Saving your changes' : `${SAVED} · ${details}`;

    return (
        <div className="saving-status">
            <Tooltip title={tooltip}>
                <span className="saving-status__current" aria-label={tooltip}>
                    {isSaving ? <StatusLine isSaving label={SAVING} /> : <StatusLine label={SAVED} details={details} />}
                </span>
            </Tooltip>
            {details && (
                <span className="saving-status__ghost" aria-hidden="true">
                    <StatusLine label={SAVED} details={details} />
                </span>
            )}
        </div>
    );
};

export default SavingStatus;
